
export const API_IP = "78.186.223.18";
export const API_PORT = "6002";